import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { ErrorService } from '../../../../@core/utils/error.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { ContractDTO } from '../models/contract';
import { ContractLineDTO } from '../models/lineItem';

@Injectable({
  providedIn: 'root'
})
export class ContractLinesService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
    private errorService: ErrorService
  ) {
    // this.basePath = environment.HOLLINGBERY_API_URL;
    this.basePath = environment.PLATFORM_API_URL;


  }


  public getContractLines(contractId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.basePath}/api/lineitem`);
  }
  public getContractLinesById(id: number): Observable<any> {
    return this.httpClient.get<any>(`${this.basePath}/api/contractlines/${id}`);
  }

  public getContractLinesByContractId(id: number): Observable<any> {
    return this.httpClient.get<any>(`${this.basePath}/api/contractlines/byContractId/${id}`);
  }

  public postContractLines(dto: ContractLineDTO): Observable<ContractLineDTO> {
    return this.httpClient.post<ContractLineDTO>(`${this.basePath}/api/contractlines`, dto);
  }
  public putContractLines(dto: ContractLineDTO): Observable<ContractLineDTO> {
    return this.httpClient.put<ContractLineDTO>(`${this.basePath}/api/contractlines/${dto.id}`, dto);
  }
}
